export default {
      id: "arrow-down-usage",
      viewBox: "0 0 64 36.0004",
      url: __webpack_public_path__ + "sprite.svg#arrow-down",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./static/images/sprite-icons/arrow-down.svg
// module id = mE25
// module chunks = 1